<template>

  <div class="portlet_wrapper">
  
    <div class="cnt_block">
      <div class="table_holder">
        <table>
          <thead>
            <tr> <th>日期</th> <th>時間</th> <th>活動群組</th> <th>兌換商品</th> <th>使用點數</th> </tr>
          </thead>
          <tbody v-if="exchangeRecordGetter.length">
            <tr v-for="tr in exchangeRecordGetter">
              <td>{{ tr.record_date }}</td>
              <td>{{ tr.record_time }}</td>
              <td>{{ tr.record_trade_events_name }}</td>
              <td>{{ tr.record_name }}</td>
              <td>{{ tr.record_cost }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr><td colspan="4" style="text-align: left;"></td></tr>
          </tbody>
        </table>
      </div>
    </div>
    
  </div>
  
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ExchangeRecord',
  components: {
  },
  props: {
    currentStudent: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('pages/point', [
      'exchangeRecordGetter'
    ])
  },
  watch: {
    currentStudent() {
      this.updateViewTable();
    },
  },
  created () {
    this.updateViewTable();
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/point', [
      'getStudentTradeList',
    ]),
    updateViewTable() {
    this.togglePageLoader(true);
      this.getStudentTradeList({
        student_id: this.currentStudent.student_pk_id,
      }).then(() => this.togglePageLoader(false))
        .catch(()=> this.togglePageLoader(false));
    },
  }
}
</script>